const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export default months;

export const DELEGATE_ACCESS_ACTIONS = {
  DELEGATE_ACCESS: 'DELEGATE_ACCESS',
  REVOKE_ACCESS: 'REVOKE_ACCESS',
  REGION_USER_LIST: 'REGION_USER_LIST',
  TOGGLE_SHOW_DIALOG: 'TOGGLE_SHOW_DIALOG',
  DELEGATE_ACCESS_RECORDS: 'DELEGATE_ACCESS_RECORDS',
};

export const COMPETITORS_ACTIONS = {
  GET_COMPETITORS: 'GET_COMPETITORS',
  UPDATE_COMPETITORS: 'UPDATE_COMPETITORS',
  SET_LOADING: 'SET_LOADING',
  UPDATE_WEIGHT: 'UPDATE_COMPETITOR_WEIGHT',
};

export const ECRI_ACTIONS = {
  FETCH_DATA: 'FETCH_DATA',
  FETCH_STATS: 'FETCH_STATS',
  SET_REGION_OPTIONS: 'SET_REGION_OPTIONS',
  APPLY_FILTERS: 'APPLY_FILTERS',
  SET_LOADING: 'SET_LOADING',
  TOGGLE_UNIT_DETAILS: 'TOGGLE_UNIT_DETAILS',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_UNIT_SIZE: 'SET_UNIT_SIZE',
  SET_REGION: 'SET_REGION',
  SET_STATUS: 'SET_STATUS',
  SET_STORE: 'SET_STORE',
  OPEN_EDIT_MODE: 'OPEN_EDIT_MODE',
  CLOSE_EDIT_MODE: 'CLOSE_EDIT_MODE',
  APPROVE_OFFER: 'APPROVE_OFFER',
  EXCLUDE_OFFER: 'EXCLUDE_OFFER',
  PENDING_OFFER: 'PENDING_OFFER',
  SAVE_OFFER: 'SAVE_OFFER',
  SUGGEST_IN_LEASE_PRICE: 'SUGGEST_IN_LEASE_PRICE',
  APPROVE_ALL_OFFERS: 'APPROVE_ALL_OFFERS',
  PENDING_ALL_OFFERS: 'PENDING_ALL_OFFERS',
  EXCLUDE_ALL_OFFERS: 'EXCLUDE_ALL_OFFERS',
  OPEN_EXPORT_MODAL: 'OPEN_EXPORT_MODAL',
  SET_EXPORT_READY: 'SET_EXPORT_READY',
  CLOSE_EXPORT_MODAL: 'CLOSE_EXPORT_MODAL',
  SET_EXPORT_DATA: 'SET_EXPORT_DATA',
  FETCH_IN_LEASE_PRICE_SUGGESTIONS: 'FETCH_IN_LEASE_PRICE_SUGGESTIONS',
  APPROVE_IN_LEASE_PRICE_SUGGESTION: 'APPROVE_IN_LEASE_PRICE_SUGGESTION',
  UPDATE_IN_LEASE_PRICE_SUGGESTIONS: 'UPDATE_IN_LEASE_PRICE_SUGGESTIONS',
  UPDATE_IN_LEASE_PRICE_OVERRIDES: 'UPDATE_IN_LEASE_PRICE_OVERRIDES',
};

export const MESSAGES = {
  ERROR_FETCH_IN_LEASE_PRICE_SUGGESTIONS: {
    message: 'Something went wrong while fetching lease price suggestions',
    type: 'error',
  },
  ERROR_APPROVE_IN_LEASE_PRICE_SUGGESTION: {
    message: 'Something went wrong while approving lease price suggestion',
    type: 'error',
  },
  APPROVE_IN_LEASE_PRICE_SUGGESTION: {
    message: 'Lease price suggestion has been approved',
    type: 'success',
  },
  DELEGATE_ACCESS_DATE_RANGE_EXCEPTION: {
    message:
      'Delegation for this destination and given date range already exists',
    type: 'error',
  },
  DELEGATE_ACCESS_SUCCESS: {
    message: 'Access delegated successfully',
    type: 'success',
  },
  COMPETITORS_DATA_FETCH_SUCCESS: {
    message: 'Competitors data fetched succesfully',
    type: 'success',
  },
  COMPETITORS_DATA_FETCH_FAILED: {
    message: 'Competitors data not fetched',
    type: 'success',
  },
  COMPETITORS_DATA_UPDATE_SUCCESS: {
    message: 'Competitors data succesfully updated',
    type: 'success',
  },
  COMPETITORS_DATA_UPDATE_FAILED: {
    message: 'Competitors data update failed',
    type: 'error',
  },
  ECRI_STATS_FETCH_FAILED: {
    message: 'Fetching stats failed',
    type: 'error',
  },
  ECRI_DATA_FETCH_FAILED: {
    message: 'Fetching data failed',
    type: 'error',
  },
  ECRI_OFFER_APPROVED: {
    message: 'Offer has been approved',
    type: 'success',
  },
  ECRI_OFFERS_APPROVED: {
    message: 'All Offers has been approved',
    type: 'success',
  },
  ECRI_OFFER_PENDING: {
    message: 'Status set to pending for selected offer',
    type: 'success',
  },
  ECRI_OFFERS_PENDING: {
    message: 'Status restored to pending for all offers',
    type: 'success',
  },
  ECRI_OFFER_EXCLUDED: {
    message: 'Offer has been excluded',
    type: 'success',
  },
  ECRI_OFFER_SAVED: {
    message: 'Offer has been saved',
    type: 'success',
  },
  ECRI_OFFER_SUGGESTED: {
    message: 'Offer has been suggested',
    type: 'success',
  },
  ECRI_APPROVE_SUGGESTED: {
    message: 'Approval has been suggested',
    type: 'success',
  },
  ECRI_EXCLUDE_SUGGESTED: {
    message: 'Exclusion has been suggested',
    type: 'success',
  },
  ECRI_REPORT_EXPORT_FAILED: {
    message: 'No data to export',
    type: 'error',
  },
};

export const UserRoles = {
  superAdmin: 'super-admin',
  admin: 'admin',
  readWrite: 'read-write',
  readOnly: 'read-only',
  reportsOnly: 'reports-only',
};
